import * as React from "react";
const SvgBlank = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-d765b6a5-fa33-4ff1-b1f6-af8a280f77f6", "data-name": "blocked", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20,12c0,4.42-3.58,8-8,8s-8-3.58-8-8S7.58,4,12,4s8,3.58,8,8ZM19,12c0,3.87-3.13,7-7,7-1.75,0-3.36-.64-4.58-1.71l9.87-9.87c1.06,1.23,1.71,2.83,1.71,4.58ZM6.71,16.58l9.87-9.87c-1.23-1.06-2.83-1.71-4.58-1.71-3.87,0-7,3.13-7,7,0,1.75.64,3.36,1.71,4.58Z", style: {
  fill: "currentColor",
  fillRule: "evenodd",
  strokeWidth: 0
} }));
export default SvgBlank;
